import { Link } from "react-router-dom";

function Admission() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">Admission</li>
          <li className="breadcrumb-item active">Admission</li>
        </ul>
      </div>

      <div className="innersec container my-5">
        <div className="row g-3">
          <div className="col-lg-12">
            <h1>Admission</h1>

            {/* Image from public folder */}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Admission.jpg"
              alt="Admission"
              className="img-fluid mt-3  admission_sec_img"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Admission;
